var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.bindUsers.length > 0||_vm.unbindUsers.length>0)?_c('el-transfer',{staticStyle:{"margin-top":"20px"},attrs:{"data":_vm.unbindUsers,"filterable":"","titles":['待选列表', '选中列表'],"filter-method":_vm.filterUser,"target-order":"unshift","props":{
    key: 'id',
    label: 'name'
  }},on:{"change":_vm.onTransferChanged},model:{value:(_vm.bindUsers),callback:function ($$v) {_vm.bindUsers=$$v},expression:"bindUsers"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }